import { useOverlaysStore } from '@/stores/overlays'

export function useDrawers () {
  const { openDrawer, closeDrawer, minimizeDrawer } = useOverlaysStore()

  const chatbotDrawer = {
    open() { openDrawer('chatbot', { minimized: false }) },
    close() { closeDrawer('chatbot') },
    minimize() { minimizeDrawer('chatbot') }
  }
  
  return {
    chatbotDrawer,
  }
}

export default useDrawers
